import React from 'react';
import { Container, Accordion, Button } from 'react-bootstrap';
import { faqData, createGeneralWhatsappUrl } from '../data/faqData';
import './FAQPage.css';

const FAQPage = ({ onNavigate }) => {
  const whatsappUrl = createGeneralWhatsappUrl();

  const handleOrderNow = () => {
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="faq-page" dir="rtl">
      <Container className="faq-container">
        {/* Header */}

        {/* Main Title and Subtitle */}
        <div className="faq-title-section">
          <h1 className="main-title">الأسئلة الشائعة</h1>
          <p className="subtitle">
            ابحث عن إجابات للأسئلة الأكثر شيوعًا حول الملابس لدينا.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="faq-accordion-section">
          <Accordion defaultActiveKey="0" className="faq-accordion">
            {faqData.map((faq, index) => (
              <Accordion.Item
                key={faq.id}
                eventKey={index.toString()}
                className="faq-item"
              >
                <Accordion.Header className="faq-header-item">
                  <span className="faq-question">{faq.question}</span>
                  <span className="faq-arrow">‹</span>
                </Accordion.Header>
                <Accordion.Body className="faq-body">
                  <p className="faq-answer">{faq.answer}</p>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>

        {/* Call to Action Section */}
        <div className="cta-section">
          <div className="cta-content">
            <p className="cta-question">ألم تجد ما تبحث عنه؟</p>
            <p className="cta-contact">
              اتصل بنا على{' '}
              <a href="mailto:contact@moda-lady.shop" className="contact-email">
                contact@moda-lady.shop
              </a>
            </p>
          </div>
        </div>

        {/* Order Now Button */}
        <div className="order-button-section">
          <Button
            className="order-now-button"
            onClick={handleOrderNow}
          >
            اطلبي الآن
          </Button>
        </div>

        {/* Footer */}
        <div className="faq-footer">

          <p className="tagline">
            الراحة التي يمكنك الاعتماد عليها.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default FAQPage;
